import { Skeleton } from "primereact/skeleton";
import { Message } from "primereact/message";
import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TabPanel, TabView } from "primereact/tabview";
import { CatalogItem } from "./CatalogItem";
import "./Catalog.scss";
import {
  useLazyGetCatalogQuery,
} from "../../libraries/DataLibrarySlice";
import {
  NodeDefinition,
  setFilter,
} from "../editorSlice";
import { useAppSelector, useAppDispatch } from "../../../hooks/hooks";
import { useTranslation } from "react-i18next";
import { setToast } from "../../../app/appSlice";
import { NodeKind } from '../diagram/nodes/DataNodeModel';

export const Catalog = () => {
  const [getCatalog, { data: catalog, ...statusCatalog }] =
    useLazyGetCatalogQuery();
  const [items, setItems] = useState<any[]>([]);
  const filter = useAppSelector((state) => state.editor.filter);
  const topology = useAppSelector((state) => state.editor.current);
  const dispatch = useAppDispatch();

  const [activeIndex, setActiveIndex] = useState(0);

  const { t } = useTranslation();

  useEffect(() => {
    if (topology && !catalog) {
      getCatalog({ runtimeType: topology.runtimeMode },true);
    }
  }, [topology]);

  const renderTab = (header: string, items: NodeDefinition[]) => {
    let it = items.filter(
      (n: any) =>
        n.name.toLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1 &&
        !n.id_source_externe
    );

    return (
      <TabPanel
        key={header}
        header={
          <div>
            {header} ({it.length})
          </div>
        }
      >
        <div className="scroller">
          {it.length === 0 && <div className="m-2">Aucun résultat</div>}
          {it.length > 0 &&
            it.map((n: NodeDefinition) => (
              <CatalogItem
                key={header + n.name}
                title={n.name}
                icon={n.icon}
                type={n.type}
                model={n}
              />
            ))}
        </div>
      </TabPanel>
    );
  };
  useEffect(() => {
    if (catalog) {
      setItems([
        renderTab(t("table.sources"), catalog.sources),
        renderTab(t("table.functions"), catalog.functions),
        renderTab(t("table.sinks"), catalog.sinks),
        renderTab(t("table.others"), [{
            name: t("table.comment"),
            kind: NodeKind.NOTE,
            type: 'sticky-note',
            description: t("table.comment_description"),
            settings: {},
            icon: '/images/document.svg'
        }])
      ]);
    }
  }, [catalog, filter]);

  if (statusCatalog.isLoading)
    return (
      <div className="grid p-0 editor-catalog">
        <div className="col-12">
          <Skeleton width="100%" height="20px" />
        </div>
        <div className="col-12">
          <Skeleton width="100%" height="20px" />
        </div>
        <div className="col-12">
          <Skeleton width="100%" height="20px" />
        </div>
        <div className="col-12">
          <Skeleton width="100%" height="20px" />
        </div>
        <div className="col-12">
          <Skeleton width="100%" height="20px" />
        </div>
      </div>
    );

  if (statusCatalog.isError)
    return (
      <div className="grid p-0 editor-catalog">
        <div className="col-12">
          <div>
            <Message
              severity="error"
              text={t("message.component.error-retrieve-datasets")}
            />
          </div>
        </div>
      </div>
    );
  return (
    <div className="flex flex-column editor-catalog">
      <div className="grid p-fluid p-2">
        <div className="col">
          <InputText
            className="m-1"
            placeholder={t("label.find")}
            value={filter}
            onChange={(e) => {
              dispatch(setFilter(e.target.value));
            }}
          />
        </div>
        <div className="flex col-3">
          <Button
            className="p-button-text p-button-sm m-1"
            onClick={async () => {
              try {
                if (topology) {
                    await getCatalog({ runtimeType: topology.runtimeMode }).unwrap();
                    dispatch(
                        setToast({
                            title: "Synchronisation des briques",
                            content: "Synchronisation effectuée avec succés",
                            severity: "success",
                            life: 3000,
                        })
                    );
                }
              } catch {
                dispatch(
                  setToast({
                    title: "Synchronisation des briques",
                    content: "Echec de la synchronisation",
                    severity: "error",
                    life: 3000,
                  })
                );
              }
            }}
            disabled={statusCatalog.isLoading}
          >
            <FontAwesomeIcon
              icon={"sync"}
              spin={statusCatalog.isLoading}
            />
          </Button>
        </div>
      </div>
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        {items}
      </TabView>
    </div>
  );
};
